import { AlertTriangle } from 'lucide-react';
import { CARDAPIO_DOMINIO_BASE } from '../../config/cardapio';

export default function CardapioLicencaBloqueada({
  nomeRestaurante,
  mensagem,
}: {
  nomeRestaurante?: string;
  mensagem: string;
}) {
  return (
    <div className="min-h-screen bg-neutral-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg border border-red-200 p-6 text-center">
        <AlertTriangle className="w-12 h-12 text-red-500 mx-auto mb-3" />
        <h1 className="text-lg font-bold text-black">
          {nomeRestaurante ? `${nomeRestaurante} — indisponível` : 'Cardápio indisponível'}
        </h1>
        <p className="text-sm text-neutral-600 mt-2">{mensagem}</p>
        <p className="text-[11px] text-neutral-400 mt-4">
          Cardápio Digital · {CARDAPIO_DOMINIO_BASE.replace('https://', '')}
        </p>
      </div>
    </div>
  );
}
